// Status renderer for ConceptLinkerValidator (parent entity)
export function conceptValidatorStatusRenderer(params: { value?: number }) {
  if (params.value === undefined || params.value === null) {
    return '';
  }

  const status = params.value;

  // ConceptLinkerValidator status values
  const STATUS_PENDING = 0;
  const STATUS_NEEDS_USER_REVIEW = 1;
  const STATUS_DONE = 2;

  switch (status) {
    case STATUS_PENDING:
      // Hourglass icon for pending
      return '<span class="fa fa-circle-pause" style="color: #ff9800;" title="Pending"></span>';

    case STATUS_NEEDS_USER_REVIEW:
      // User icon for needs user review
      return '<span class="fa fa-user" style="color: #2196f3;" title="Needs User Review"></span>';

    case STATUS_DONE:
      // Check circle icon for done
      return '<span class="fa fa-check-circle" style="color: #4caf50;" title="Done"></span>';

    default:
      return '';
  }
}
